import { Component } from '@angular/core';

import {
  AuthService,
  IUserProfile,
  SilentSsoLoginService,
} from '@account-users';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  constructor(
    public readonly auth: AuthService,
    private readonly silentSSOLoginService: SilentSsoLoginService,
  ) {
    if (!this.auth.isAuthenticated() && this.silentSSOLoginService.userEmail) {
      this.auth.login();
    }
  }

  get profile(): IUserProfile {
    return this.auth.profile;
  }
}
